import React from 'react';
import PropTypes from 'prop-types';

import { FormLabel as MuiFormLabel } from '@material-ui/core';

const FormLabel = ({ children, ...rest }) => {
  return (
    <MuiFormLabel
      {...rest}
    >
      { children }
    </MuiFormLabel>
  )
}

FormLabel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormLabel;



// WEBPACK FOOTER //
// ./src/components/base/FormLabel/FormLabel.js